export default __webpack_public_path__ + "11cd1d79299f3bb42d0066d2f6573467.ttf";